/* RESPONSIBLE TEAM: team-standalone */
import BaseValidator from 'ember-cp-validations/validators/base';
import { inject as service } from '@ember/service';
import type Store from '@ember-data/store';
import type IntlService from 'ember-intl/services/intl';
import type Environment from 'embercom/models/environments/environment';

export default class RulesetHasValidEnvironmentIds extends BaseValidator {
  @service declare store: Store;
  @service declare intl: IntlService;

  async validate(_value: unknown, _options: unknown, model: any) {
    let environmentIds: number[] | null = model.environmentIds;

    // "All environments" mode — always valid
    if (!environmentIds || environmentIds.length === 0) {
      return true;
    }

    let existingEnvironments = (await this.store.findAll('environments/environment')).slice();

    let existingIds = existingEnvironments.map((env: Environment) => Number(env.id));
    let allValid = environmentIds.every((id: number) => existingIds.includes(id));

    if (!allValid) {
      return this.intl.t('standalone.common.environment-config.validation-error');
    }

    return true;
  }

  static getDependentsFor() {
    return ['model.environmentIds.[]'];
  }
}
